<template>
  <div :class="['container', isActive ? 'active' : '']" @click="$emit('clicked')" @mouseenter="isPaused=true" @mouseleave="isPaused=false">
    <component class="picture" :is="iconComponent" :name="iconName"/>
    <svg class="border-container" width="50px" height="50px" viewBox="0 0 50 50">
      <circle class="border" r="20" cx="25" cy="25"></circle>
      <circle class="timer" transform="rotate(-90 25 25)" v-show="isActive" r="19" cx="25" cy="25"></circle>
    </svg>
  </div>
</template>


<script>
export default {
  name: 'SectionIcon',
  props: {
    iconName: String,
    isActive: Boolean,
  },
  data() {
    return {
      isPaused: false,
    }
  },
  computed: {
    iconComponent() {
      if (this.iconName.startsWith('jam-')) {
        return this.iconName
      }
      return 'unicon'
    }
  },
  watch: {
    isPaused() {
      this.circleElement.style.animationPlayState = this.isPaused ? 'paused' : 'running'
    },
  },
  mounted() {
    this.circleElement = this.$el.querySelector('.timer') // non-reactive
    this.circleElement.addEventListener('animationend', () => {
      this.$emit('next-section')
    })
  },
}
</script>


<style scoped>
.container {
  flex: 1 0 50px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  fill: lightgray;
}

.active {
  fill: black;

}

.timer {
  stroke-dasharray: 120px;
  stroke-dashoffset: 0px;
  stroke-linecap: square;
  stroke-width: 4px;
  stroke: black;
  fill: none;
  animation: countdown 20s linear forwards;
}

.border-container {
  position: absolute;
}


.border {
  stroke-linecap: round;
  stroke-width: 2px;
  stroke: lightgray;
  fill: none;
}

.active .border {
  stroke: black;
}

@keyframes countdown {
  from {
    stroke-dashoffset: 0px;
  }
  to {
    stroke-dashoffset: 120px;
  }
}

</style>

